<template>
	<div class="ChecklistItem" :class="classes">
		<a v-if="checklist.numSpecies != null" :href="baseUrl + 'checklist/' + checklist.subId" class="ChecklistItem-species">
			<span class="ChecklistItem-species-count">{{ checklist.numSpecies }}</span>
			<span class="ChecklistItem-species-label">{{ $t('generic.Species') }}</span>
		</a>
		<div class="ChecklistItem-date">
			<!-- <CloHeading :level="3" :size="3" inline>
				<template>DD MMM YYYY</template>
				<template v-slot:sub>HH:MM</template>
			</CloHeading> -->
			<h3 class="Heading">
				<a :href="baseUrl + 'checklist/' + checklist.subId">
					<span class="Heading-main">{{ checklist.obsDt }}</span>
					<span class="Heading-sub Heading-sub--inline">{{ checklist.obsTime }}</span>
				</a>
			</h3>
		</div>

		<div class="ChecklistItem-location">
			<!-- TODO - decide how to divide this. We have locName and hierarchicalName, plus the individual loc pieces.
			Seems like hierarchicalName was added as a utility for display here...
			-->
			<!--<div class="Checklist-location-loc">{{ checklist.loc.locName }}</div>-->
			<div class="ChecklistItem-location-regions">{{ checklist.loc.hierarchicalName }}</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue';
import CloIcon from '@/icons/CloIcon/CloIcon';
import CloHeading from '@/base/CloHeading/CloHeading.vue';

export default Vue.extend({
	name: 'ChecklistItem',
	components: {
		CloIcon,
		CloHeading,
	},
	data() {
		return {
			baseUrl: window.baseUrl,
		};
	},
	props: {
		checklist: {
			type: Object,
			default: {},
		},
		edit: Boolean,
	},
	computed: {
		classes() {
			return {
				'ChecklistItem--edit': this.edit,
			};
		},
	},
});
</script>

<style lang="scss">
.ChecklistItem {
	display: grid;
	grid-column-gap: $space-md;
	grid-template-columns: auto auto 1fr;
	grid-template-rows: auto auto;
	align-items: baseline;
	grid-template-areas:
		'species date date'
		'species location location';
	.ChecklistItem-date {
		min-width: 10rem;
	}
	&--edit {
		grid-template-areas:
			'date date date'
			'location location location';
	}
}

.ChecklistItem-species {
	grid-area: species;
	@include inset-sm;
	border-radius: $radius-sm;
	color: $color-white;
	background-color: $color-primary-3;
	display: flex;
	flex-direction: column;
	align-items: center;
	align-self: start;
	gap: $space-xs;
	min-width: $space-xl;
	.ChecklistItem-species-count {
		@include text(5);
		font-weight: bold;
		letter-spacing: -0.01rem;
		line-height: 1;
	}
	.ChecklistItem-species-label {
		@include text(1);
		text-transform: uppercase;
	}
	&:hover,
	&:active,
	&:focus {
		color: $color-white;
	}
}

.ChecklistItem-date {
	grid-area: date;
	.Heading {
		margin: 0;
	}
}

.ChecklistItem-location {
	grid-area: location;
	@include text(3);
	color: $color-text-muted;
	display: flex;
	align-items: baseline;
	flex-wrap: wrap;
	.Checklist-location-loc {
		@include inline-sm;
	}
	.Checklist-location-regions {
		color: $color-text-muted;
		@include text(2);
	}
}
</style>
